module.exports = __webpack_public_path__ + "img/recruit-black.8967ba19.svg";